import { Directive, inject } from '@angular/core';
import { UserService } from '../models/users/userService';

@Directive()
export abstract class BasePage {
  static userService: UserService;

  preserveBrowserBack: boolean = false;

  private _backFcn: Function | undefined;
  //private _navEventSubscription:Subscription | undefined;
  //private _router = inject(Router);

  constructor() {
    BasePage.userService = inject(UserService);
  }

  ngOnInit() {
    if (!this.preserveBrowserBack) {
      this._preventBackNavigation();

      if (this._backFcn) {
        window.addEventListener('beforeunload', (event) => {
          if (this._backFcn) {
            this._backFcn.call(this, null);
          }
          event.preventDefault();
        });
      }
    }
  }

  // ngOnDestroy() {
  //     if (this._navEventSubscription) {
  //         this._navEventSubscription.unsubscribe();
  //     }
  // }

  public setBackFunction(callback: Function) {
    this._backFcn = callback;
  }

  private _preventBackNavigation() {
    history.pushState(null, '', window.location.href);

    // Detect when user presses back
    window.addEventListener('popstate', () => {
      history.pushState(null, '', window.location.href); // Block navigation
    });

    // Alternative: Redirect instead of blocking
    // this._navEventSubscription = this._router.events.subscribe(event => {
    //   if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
    //     this._router.navigate(['/']); // Redirect user to home
    //   }
    // });
  }
}
